"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ToAlarm = function ToAlarm(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 41.61 24",
    width: "41.61",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#004864"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m.9 11.74h10.71l-1.61-1.64a.91.91 0 0 1 1.28-1.28l3.14 3.18a.9.9 0 0 1 0 1.27l-3.18 3.18a.91.91 0 0 1 -1.28 0 .9.9 0 0 1 0-1.27l1.65-1.65h-10.71a.9.9 0 1 1 0-1.8z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m38.13 21a1.53 1.53 0 0 1 -1.52-1.53v-4.47a7 7 0 0 0 -4-6.33 3 3 0 0 0 -5.93 0 7 7 0 0 0 -4 6.33v4.5a1.53 1.53 0 0 1 -1.58 1.5.47.47 0 0 0 -.48.48.48.48 0 0 0 .48.48h6.08a2.48 2.48 0 0 0 4.87 0h6.08a.49.49 0 0 0 .48-.48.48.48 0 0 0 -.48-.48z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m21.1 9.48a.48.48 0 0 1 -.48-.48 6 6 0 0 1 6-6 .48.48 0 0 1 .48.48.49.49 0 0 1 -.48.48 5 5 0 0 0 -5 5 .49.49 0 0 1 -.52.52z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m18.09 9.48a.49.49 0 0 1 -.48-.48 9 9 0 0 1 9-9 .48.48 0 1 1 0 1 8 8 0 0 0 -8 8 .48.48 0 0 1 -.52.48z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m38.13 9.48a.48.48 0 0 1 -.48-.48 5 5 0 0 0 -5-5 .48.48 0 0 1 -.48-.48.47.47 0 0 1 .45-.52 6 6 0 0 1 6 6 .49.49 0 0 1 -.49.48z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m41.13 9.48a.49.49 0 0 1 -.48-.48 8 8 0 0 0 -8-8 .47.47 0 0 1 -.48-.48.47.47 0 0 1 .45-.52 9 9 0 0 1 9 9 .48.48 0 0 1 -.49.48z"
  })));
};

var _default = ToAlarm;
exports["default"] = _default;